// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopBanner_container__tPMOs"};